export default "__VITE_ASSET__CmJF1uvX__"